import React from 'react';

export default {
  svg: (
    <g>
      <g>
        <circle fill="#50E3C2" strokeWidth={0} cx={40.522} cy={39.885} r={38.5} />
        <path
          fill="#FFFFFF"
          strokeWidth={0}
          d="M40.522,2.384c20.711,0,37.5,16.789,37.5,37.5s-16.789,37.5-37.5,37.5s-37.5-16.789-37.5-37.5 S19.812,2.384,40.522,2.384 M40.522,0.384c-21.78,0-39.5,17.72-39.5,39.5s17.72,39.5,39.5,39.5s39.5-17.72,39.5-39.5 S62.303,0.384,40.522,0.384L40.522,0.384z"
        />
      </g>
      <g>
        <path
          fill="none"
          strokeWidth={0}
          d="M40.522,2.384c-20.711,0-37.5,16.789-37.5,37.5c0,12.796,6.414,24.089,16.197,30.856 c0.009-5.97,4.895-10.85,10.865-10.85h3.331v-0.991c-4.534-1.999-8.057-6.005-10.273-10.79c-0.172,0.4-0.488,0.661-1.03,0.733 c-1.821,0.244-2.717-1.966-3.408-4.747s-1.504-5.003,0.317-5.246c0.551-0.074,1.083,0.065,1.572,0.364 c-0.295-2.957-0.753-4.369-0.518-7.947c0.249-3.806,1.129-7.357,3.146-10.335c1.893-2.796,4.757-5.01,7.869-6.479 c3.11-1.469,6.279-2.263,9.658-2.027c3.378-0.236,6.547,0.558,9.657,2.027c3.113,1.469,5.977,3.683,7.87,6.479 c2.016,2.978,2.896,6.529,3.145,10.335c0.111,1.703,0.095,3.454-0.002,5.225c-0.089,0.972-0.199,1.793-0.283,2.565 c0.407-0.188,0.841-0.267,1.285-0.207c1.821,0.244,1.009,2.465,0.317,5.246c-0.692,2.781-1.588,4.991-3.409,4.747 c-0.531-0.071-0.844-0.325-1.019-0.712c0,0,0,0.001-0.001,0.001c-0.196,0.422-0.403,0.838-0.619,1.247 c-0.009,0.017-0.018,0.033-0.027,0.05c-0.208,0.392-0.425,0.777-0.652,1.155c-0.018,0.031-0.037,0.061-0.056,0.092 c-0.218,0.361-0.444,0.715-0.678,1.063c-0.03,0.044-0.06,0.088-0.091,0.132c-0.225,0.329-0.458,0.651-0.697,0.967 c-0.043,0.057-0.086,0.113-0.13,0.169c-0.231,0.298-0.468,0.589-0.712,0.873c-0.057,0.066-0.113,0.132-0.171,0.197 c-0.235,0.268-0.476,0.528-0.723,0.782c-0.071,0.073-0.142,0.147-0.214,0.219c-0.238,0.238-0.481,0.468-0.729,0.692 c-0.087,0.079-0.173,0.158-0.261,0.235c-0.24,0.209-0.485,0.41-0.734,0.606c-0.102,0.081-0.203,0.162-0.306,0.241 c-0.242,0.183-0.489,0.356-0.739,0.526c-0.116,0.079-0.231,0.161-0.349,0.237c-0.244,0.158-0.493,0.305-0.744,0.45 c-0.131,0.076-0.259,0.154-0.392,0.226c-0.246,0.133-0.497,0.255-0.749,0.376c-0.144,0.069-0.287,0.143-0.433,0.208 c-0.244,0.109-0.495,0.205-0.745,0.302v0.712h3.449c5.977,0,10.866,4.89,10.866,10.867v0.091 c9.87-6.755,16.349-18.101,16.349-30.964C78.022,19.174,61.233,2.384,40.522,2.384z"
        />
        <path
          fill="#FE0002"
          strokeWidth={0}
          d="M50.807,59.891h-3.449v3.809c0.056,0.004,0.111,0.007,0.166,0.011c0.001-0.111,0.001-0.215,0.002-0.326 c3.44,0.017,5.209,0.098,7.883,1.428c-0.04,0.202-0.076,0.394-0.115,0.592c2.597,1.273,4.236,3.271,5.423,6.071 c0.321-0.205,0.641-0.411,0.955-0.625v-0.091C61.673,64.78,56.784,59.891,50.807,59.891z"
        />
        <path
          fill="#FE0002"
          strokeWidth={0}
          d="M25.706,66.165c-0.073-0.379-0.146-0.759-0.223-1.151c2.675-1.33,4.442-1.411,7.884-1.429 c0,0.053,0.001,0.102,0.001,0.155c0.015-0.001,0.031-0.002,0.047-0.003v-3.846h-3.331c-5.97,0-10.855,4.88-10.865,10.85 c0.535,0.37,1.078,0.728,1.633,1.07C22.067,69.341,23.61,67.481,25.706,66.165z"
        />
        <path
          fill="#EBA17C"
          strokeWidth={0}
          d="M33.456,63.734v-3.906l6.493,3.663c0.239-0.003,0.478-0.006,0.718-0.007 c2.32,0.013,4.623,0.083,6.692,0.216v-3.809v-0.712c-0.006,0.002-0.012,0.005-0.018,0.007c-0.154,0.06-0.306,0.124-0.463,0.179 c-0.258,0.09-0.522,0.166-0.785,0.244c-0.162,0.048-0.322,0.102-0.486,0.144c-0.27,0.07-0.547,0.124-0.823,0.18 c-0.164,0.033-0.325,0.074-0.49,0.103c-0.302,0.052-0.61,0.085-0.918,0.119c-0.146,0.016-0.289,0.042-0.436,0.054 c-0.458,0.039-0.923,0.06-1.396,0.06c-0.273,0-0.544-0.009-0.813-0.024c-0.021,0.001-0.043,0.001-0.064,0.002 c-0.114,0.007-0.228,0.012-0.342,0.016v-0.006c-0.136,0.004-0.271,0.012-0.407,0.012c-2.346,0-4.52-0.495-6.502-1.369v0.991v3.846 C33.428,63.736,33.442,63.735,33.456,63.734z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M33.456,59.827v3.906c1.989-0.141,4.222-0.219,6.493-0.243L33.456,59.827z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M39.949,63.49c-2.271,0.024-4.504,0.102-6.493,0.243c-0.013,0.001-0.027,0.002-0.041,0.003 c-0.016,0.001-0.032,0.002-0.047,0.003c0.001,0.201,0.003,0.392,0.004,0.591c1.209,1.016,2.578,1.831,5.962,2.606l-0.121,0.132 l1.279,9.112v-0.078l1.268-9.03l-0.125-0.137c0.052-0.012,0.098-0.024,0.15-0.036l0.003-0.02c0.067-0.008,0.127-0.019,0.193-0.027 c3.058-0.733,4.391-1.507,5.538-2.457c0.002-0.23,0.003-0.453,0.005-0.685c-0.055-0.004-0.11-0.008-0.166-0.011 c-2.069-0.133-4.372-0.203-6.692-0.216C40.427,63.485,40.188,63.488,39.949,63.49z"
        />
        <path
          fill="#FFE200"
          strokeWidth={0}
          d="M25.706,66.165c-2.096,1.315-3.64,3.175-4.854,5.646c1.939,1.198,3.998,2.219,6.151,3.051 C26.786,72.208,26.332,69.42,25.706,66.165z"
        />
        <path
          fill="#FFE200"
          strokeWidth={0}
          d="M40.493,76.18l-1.279-9.112l-3.15,3.445l-2.676-3.404c0.01,3.312-0.044,6.407-0.399,9.518 c2.424,0.495,4.934,0.755,7.504,0.757V76.18z"
        />
        <path
          fill="#FFFFFF"
          strokeWidth={0}
          d="M33.372,64.33c0.008,0.946,0.013,1.872,0.015,2.779l2.676,3.404l3.15-3.445l0.121-0.132 C35.95,66.161,34.581,65.346,33.372,64.33z"
        />
        <path
          fill="#FFB800"
          strokeWidth={0}
          d="M55.295,65.404c-0.702,3.608-1.208,6.641-1.427,9.527c2.413-0.92,4.705-2.082,6.85-3.456 C59.531,68.675,57.892,66.676,55.295,65.404z"
        />
        <path
          fill="#FFB800"
          strokeWidth={0}
          d="M47.505,67.207l-2.599,3.306l-3.146-3.44l-1.268,9.03v0.078v1.203c0.01,0,0.02,0.001,0.03,0.001 c2.537,0,5.015-0.255,7.411-0.736C47.566,73.556,47.5,70.484,47.505,67.207z"
        />
        <path
          fill="#FFB800"
          strokeWidth={0}
          d="M41.787,66.88l-0.003,0.02c0.067-0.016,0.131-0.031,0.196-0.047C41.915,66.862,41.854,66.872,41.787,66.88z "
        />
        <path
          fill="#FFFFFF"
          strokeWidth={0}
          d="M41.981,66.853c-0.065,0.016-0.129,0.031-0.196,0.047c-0.051,0.012-0.098,0.024-0.15,0.036l0.125,0.137 l3.146,3.44l2.599-3.306c0.002-0.917,0.006-1.855,0.013-2.811C46.371,65.346,45.039,66.12,41.981,66.853z"
        />
        <path
          fill="#8BC612"
          strokeWidth={0}
          d="M33.388,67.109c-0.003-0.907-0.008-1.833-0.015-2.779c-0.002-0.199-0.003-0.39-0.004-0.591 c0-0.053-0.001-0.102-0.001-0.155c-3.441,0.018-5.208,0.099-7.884,1.429c0.077,0.392,0.151,0.773,0.223,1.151 c0.625,3.255,1.08,6.043,1.297,8.697c1.925,0.745,3.922,1.344,5.986,1.765C33.343,73.516,33.397,70.421,33.388,67.109z"
        />
        <path
          fill="#7D9B00"
          strokeWidth={0}
          d="M55.295,65.404c0.039-0.198,0.075-0.39,0.115-0.592c-2.675-1.33-4.443-1.411-7.883-1.428 c-0.001,0.111-0.001,0.216-0.002,0.326c-0.002,0.232-0.003,0.456-0.005,0.685c-0.008,0.957-0.012,1.894-0.013,2.811 c-0.006,3.277,0.061,6.349,0.427,9.442c2.044-0.41,4.026-0.991,5.935-1.718C54.087,72.045,54.593,69.011,55.295,65.404z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M52.55,56.005c-0.24,0.209-0.485,0.41-0.734,0.606C52.065,56.415,52.31,56.215,52.55,56.005z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M56.187,51.872c-0.225,0.329-0.458,0.651-0.697,0.967C55.729,52.523,55.961,52.201,56.187,51.872z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M55.36,53.008c-0.231,0.298-0.469,0.589-0.712,0.873C54.891,53.596,55.129,53.306,55.36,53.008z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M58.309,48.132c-0.196,0.422-0.403,0.838-0.619,1.247C57.906,48.97,58.113,48.555,58.309,48.132z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M56.956,50.677c-0.218,0.361-0.444,0.715-0.678,1.063C56.512,51.392,56.738,51.038,56.956,50.677z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M54.477,54.078c-0.235,0.268-0.477,0.528-0.723,0.782C54.001,54.605,54.242,54.345,54.477,54.078z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M57.663,49.43c-0.208,0.392-0.426,0.777-0.652,1.155C57.238,50.207,57.455,49.822,57.663,49.43z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M49.285,58.292c-0.246,0.134-0.497,0.255-0.749,0.376C48.788,58.547,49.04,58.426,49.285,58.292z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M50.422,57.616c-0.244,0.158-0.493,0.305-0.744,0.45C49.929,57.921,50.178,57.774,50.422,57.616z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M53.54,55.079c-0.238,0.238-0.482,0.468-0.729,0.692C53.058,55.546,53.302,55.316,53.54,55.079z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M51.51,56.852c-0.241,0.183-0.489,0.356-0.739,0.526C51.021,57.209,51.268,57.035,51.51,56.852z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M47.34,59.185c0.006-0.002,0.012-0.005,0.018-0.007c0.25-0.097,0.5-0.193,0.745-0.302 C47.853,58.988,47.596,59.086,47.34,59.185z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M46.877,59.364c-0.258,0.09-0.522,0.166-0.785,0.244C46.356,59.53,46.62,59.454,46.877,59.364z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M40.667,60.246c0.021-0.001,0.043-0.001,0.064-0.002c0.269,0.015,0.54,0.024,0.813,0.024 c-0.273,0-0.544-0.009-0.813-0.025C40.71,60.244,40.688,60.245,40.667,60.246z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M44.294,60.035c-0.302,0.052-0.61,0.085-0.918,0.119C43.683,60.119,43.992,60.086,44.294,60.035z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M39.917,60.268c0.136,0,0.271-0.008,0.407-0.012v-4.744c-2.118-0.182-3.841-1.741-4.236-3.791h4.236v-2.106 c-0.267-0.05-0.566-0.155-0.912-0.357c-0.559-0.324-0.636-1.003-0.48-1.778c0.08,0.26,0.233,0.472,0.48,0.617 c0.346,0.201,0.645,0.306,0.912,0.356V30.926c-2.269,0.651-4.507,1.193-6.327,1.557c4.715-4.765-0.559-2.91-6.513-0.012 c2.175-5.475-4.464-1.628-6.846,7.198c-0.014-0.163-0.031-0.302-0.046-0.455c-0.489-0.299-1.021-0.438-1.572-0.364 c-1.821,0.244-1.009,2.465-0.317,5.246s1.588,4.991,3.408,4.747c0.542-0.073,0.857-0.333,1.03-0.733 c2.217,4.785,5.74,8.791,10.273,10.79C35.398,59.773,37.571,60.268,39.917,60.268z M27.645,37.277l5.167-0.404 c0.409-0.032,0.763,0.323,0.791,0.793c0.027,0.469-0.283,0.874-0.692,0.906l-5.167,0.403c-0.41,0.032-0.763-0.323-0.79-0.792 C26.926,37.713,27.235,37.307,27.645,37.277z M30.053,52.981c-0.804,0.447-1.975-0.123-2.616-1.273 c-0.641-1.151-0.509-2.447,0.295-2.896c0.804-0.447,1.975,0.122,2.616,1.273C30.988,51.237,30.857,52.533,30.053,52.981z  M31.392,46.133c-1.112,0-2.014-0.902-2.014-2.014c0-1.113,0.902-2.014,2.014-2.014c1.113,0,2.014,0.902,2.014,2.014 C33.406,45.231,32.504,46.133,31.392,46.133z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M44.784,59.932c0.276-0.056,0.553-0.11,0.823-0.18C45.337,59.822,45.06,59.876,44.784,59.932z"
        />
        <path
          fill="#FFCC99"
          strokeWidth={0}
          d="M42.939,60.208c-0.458,0.039-0.923,0.06-1.396,0.06C42.016,60.268,42.481,60.247,42.939,60.208z"
        />
        <path
          fill="#F5B887"
          strokeWidth={0}
          d="M60.774,39.438c-5.34-5.218-7.623-8.043-9.007-13.987c-0.757,1.868-6.182,3.967-11.443,5.475v17.526 c0.145,0.027,0.282,0.043,0.407,0.039c0.354,0.012,0.785-0.085,1.318-0.394c0.247-0.145,0.4-0.357,0.481-0.617 c0.156,0.775,0.078,1.454-0.481,1.778c-0.533,0.311-0.964,0.408-1.318,0.395c-0.125,0.004-0.262-0.011-0.407-0.039v2.106h5.048 c-0.421,2.182-2.339,3.828-4.642,3.828c-0.139,0-0.271-0.024-0.406-0.036v4.744v0.006c0.114-0.004,0.229-0.009,0.342-0.016 c0.021-0.001,0.043-0.002,0.064-0.003c0.269,0.016,0.54,0.025,0.813,0.025c0.472,0,0.937-0.021,1.396-0.06 c0.147-0.013,0.29-0.038,0.436-0.054c0.308-0.035,0.617-0.068,0.918-0.119c0.166-0.028,0.327-0.069,0.49-0.103 c0.276-0.056,0.553-0.11,0.823-0.18c0.164-0.043,0.324-0.097,0.486-0.144c0.263-0.077,0.527-0.153,0.785-0.244 c0.156-0.055,0.308-0.119,0.463-0.179c0.256-0.099,0.513-0.197,0.763-0.309c0.147-0.065,0.289-0.139,0.433-0.208 c0.252-0.121,0.504-0.243,0.749-0.376c0.133-0.072,0.261-0.151,0.392-0.226c0.251-0.145,0.501-0.292,0.744-0.45 c0.118-0.076,0.233-0.158,0.349-0.237c0.25-0.17,0.497-0.343,0.739-0.526c0.103-0.078,0.204-0.16,0.306-0.241 c0.249-0.196,0.494-0.397,0.734-0.606c0.088-0.077,0.174-0.156,0.261-0.235c0.248-0.225,0.492-0.454,0.729-0.692 c0.072-0.072,0.143-0.146,0.214-0.219c0.246-0.254,0.488-0.514,0.723-0.782c0.057-0.065,0.114-0.131,0.171-0.197 c0.244-0.284,0.481-0.575,0.712-0.873c0.043-0.056,0.087-0.112,0.13-0.169c0.24-0.315,0.472-0.638,0.697-0.967 c0.03-0.044,0.061-0.088,0.091-0.132c0.234-0.347,0.46-0.702,0.678-1.063c0.019-0.031,0.037-0.061,0.056-0.092 c0.226-0.378,0.444-0.763,0.652-1.155c0.009-0.017,0.018-0.033,0.027-0.05c0.216-0.409,0.423-0.825,0.619-1.247 c0,0,0-0.001,0.001-0.001c0.174,0.387,0.488,0.641,1.019,0.712c1.821,0.244,2.717-1.966,3.409-4.747 c0.692-2.781,1.503-5.003-0.317-5.246c-0.444-0.06-0.877,0.019-1.285,0.207c-0.023,0.213-0.045,0.423-0.063,0.63 C60.87,39.493,60.812,39.458,60.774,39.438z M48.038,44.118c0-1.113,0.902-2.014,2.014-2.014c1.113,0,2.014,0.902,2.014,2.014 c0,1.113-0.901,2.014-2.014,2.014C48.94,46.133,48.038,45.231,48.038,44.118z M53.563,51.708c-0.641,1.15-1.812,1.721-2.616,1.273 c-0.804-0.449-0.936-1.744-0.295-2.896c0.641-1.151,1.812-1.721,2.616-1.273C54.072,49.261,54.205,50.557,53.563,51.708z  M53.717,38.975l-5.167-0.403c-0.41-0.032-0.719-0.437-0.692-0.906c0.027-0.47,0.381-0.825,0.791-0.793l5.167,0.404 c0.409,0.031,0.719,0.436,0.692,0.906C54.48,38.651,54.126,39.006,53.717,38.975z"
        />
        <path
          fill="#EBA17C"
          strokeWidth={0}
          d="M42.049,49.257c0.559-0.324,0.637-1.003,0.481-1.778c-0.081,0.26-0.233,0.472-0.481,0.617 c-0.533,0.31-0.964,0.407-1.318,0.394c-0.125,0.004-0.262-0.011-0.407-0.039c-0.267-0.05-0.566-0.155-0.912-0.356 c-0.247-0.145-0.4-0.357-0.48-0.617c-0.156,0.775-0.079,1.454,0.48,1.778c0.346,0.202,0.645,0.307,0.912,0.357 c0.145,0.027,0.282,0.043,0.407,0.039C41.085,49.665,41.516,49.568,42.049,49.257z"
        />
        <path
          fill="#F5B887"
          strokeWidth={0}
          d="M27.731,48.812c-0.804,0.449-0.936,1.744-0.295,2.896c0.641,1.15,1.812,1.721,2.616,1.273 c0.804-0.449,0.936-1.744,0.294-2.896C29.706,48.934,28.535,48.365,27.731,48.812z"
        />
        <path
          fill="#EBA17C"
          strokeWidth={0}
          d="M53.269,48.812c-0.804-0.447-1.975,0.122-2.616,1.273c-0.641,1.151-0.509,2.447,0.295,2.896 c0.804,0.447,1.975-0.123,2.616-1.273C54.205,50.557,54.072,49.261,53.269,48.812z"
        />
        <path
          fill="#FFFFFF"
          strokeWidth={0}
          d="M45.373,51.72h-5.048h-4.236c0.395,2.05,2.118,3.609,4.236,3.791c0.136,0.012,0.268,0.036,0.406,0.036 C43.034,55.548,44.952,53.902,45.373,51.72z"
        />
        <path
          strokeWidth={0}
          d="M31.392,42.104c-1.112,0-2.014,0.902-2.014,2.014c0,1.113,0.902,2.014,2.014,2.014c1.113,0,2.014-0.902,2.014-2.014 C33.406,43.005,32.504,42.104,31.392,42.104z"
        />
        <path
          strokeWidth={0}
          d="M52.066,44.118c0-1.113-0.901-2.014-2.014-2.014c-1.112,0-2.014,0.902-2.014,2.014c0,1.113,0.902,2.014,2.014,2.014 C51.165,46.133,52.066,45.231,52.066,44.118z"
        />
        <path
          fill="#BD5B00"
          strokeWidth={0}
          d="M27.744,38.975l5.167-0.403c0.409-0.032,0.719-0.437,0.692-0.906c-0.028-0.47-0.382-0.825-0.791-0.793 l-5.167,0.404c-0.41,0.031-0.719,0.436-0.691,0.906C26.981,38.651,27.334,39.006,27.744,38.975z"
        />
        <path
          fill="#BD5B00"
          strokeWidth={0}
          d="M53.816,37.277l-5.167-0.404c-0.409-0.032-0.763,0.323-0.791,0.793c-0.027,0.469,0.282,0.874,0.692,0.906 l5.167,0.403c0.409,0.032,0.764-0.323,0.791-0.792C54.534,37.713,54.225,37.307,53.816,37.277z"
        />
        <path
          fill="#EE9D25"
          strokeWidth={0}
          d="M27.485,32.471c5.954-2.898,11.228-4.753,6.513,0.012c1.819-0.364,4.058-0.907,6.327-1.557 c5.261-1.508,10.686-3.607,11.443-5.475c1.384,5.945,3.667,8.769,9.007,13.987c0.038,0.02,0.096,0.055,0.298,0.248 c0.018-0.207,0.04-0.417,0.063-0.63c0.084-0.772,0.193-1.593,0.283-2.565c0.097-1.771,0.113-3.523,0.002-5.225 c-0.249-3.806-1.129-7.357-3.145-10.335c-1.894-2.796-4.758-5.01-7.87-6.479c-3.11-1.469-6.279-2.263-9.657-2.027 c-3.379-0.236-6.548,0.558-9.658,2.027c-3.112,1.469-5.976,3.683-7.869,6.479c-2.017,2.978-2.897,6.529-3.146,10.335 c-0.235,3.577,0.223,4.99,0.518,7.947c0.015,0.154,0.032,0.293,0.046,0.455C23.021,30.843,29.66,26.996,27.485,32.471z"
        />
      </g>
    </g>
  ),
  viewBox: '0 0 80 80'
};
